import { useState, useEffect, useCallback } from 'react';
import { appointmentsService, staffService } from '../services/api';
import { AppointmentModal } from '../components/AppointmentModal';
import { formatApptDateLong, formatApptTime } from '../utils/dateFormatters';
import './Appointments.css';

const STATUS_FILTERS = ['all', 'pending', 'confirmed', 'completed', 'cancelled', 'no_show'];

export default function Appointments() {
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState('all');
  const [scope, setScope] = useState('mine'); // mine | all | staffId
  const [search, setSearch] = useState('');
  const [staff, setStaff] = useState([]);
  const [modal, setModal] = useState(null);

  useEffect(() => { staffService.getAll().then((r) => r.success && setStaff(r.staff || [])); }, []);

  const load = useCallback(async () => {
    setLoading(true);
    const params = {};
    if (status !== 'all') params.status = status;
    if (search) params.search = search;
    if (scope === 'all') params.view = 'all';
    else if (scope !== 'mine') params.staffId = scope;
    const res = await appointmentsService.getAll(params);
    if (res.success) setAppointments(res.appointments || []);
    setLoading(false);
  }, [status, scope, search]);

  useEffect(() => {
    const t = setTimeout(load, search ? 300 : 0);
    return () => clearTimeout(t);
  }, [load]);

  return (
    <div className="appointments-page">
      <div className="page-header">
        <h1 className="page-title">Appointments</h1>
        <button className="btn btn-primary" onClick={() => setModal({ create: true })}>+ New Appointment</button>
      </div>

      <div className="appt-filters">
        <input className="appt-search" placeholder="Search by client…" value={search} onChange={(e) => setSearch(e.target.value)} />
        <select value={status} onChange={(e) => setStatus(e.target.value)}>
          {STATUS_FILTERS.map((s) => <option key={s} value={s}>{s === 'all' ? 'All statuses' : s.replace('_', ' ')}</option>)}
        </select>
        <select value={scope} onChange={(e) => setScope(e.target.value)}>
          <option value="mine">Mine</option>
          <option value="all">Everyone</option>
          {staff.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
        </select>
      </div>

      {loading ? (
        <div className="empty-state"><div className="loading-spinner"></div></div>
      ) : appointments.length === 0 ? (
        <div className="empty-state"><p>No appointments found</p></div>
      ) : (
        <div className="appt-list">
          {appointments.map((a) => (
            <button key={a.id} className="appt-row" onClick={() => setModal({ appointment: a })}>
              <div className="appt-when" style={{ borderLeftColor: a.staff_color || 'var(--color-teal)' }}>
                <span className="appt-row-date">{formatApptDateLong(a.starts_at)}</span>
                <span className="appt-row-time">{formatApptTime(a.starts_at)}</span>
              </div>
              <div className="appt-main">
                <h3>{a.service_name || 'Appointment'}</h3>
                <p className="text-muted">{a.client_name || '—'} · {a.staff_name}</p>
              </div>
              <span className={`status-badge status-${a.status.replace('_', '-')}`}>{a.status.replace('_', ' ')}</span>
            </button>
          ))}
        </div>
      )}

      <AppointmentModal
        isOpen={!!modal}
        onClose={() => setModal(null)}
        onSave={() => { setModal(null); load(); }}
        appointment={modal?.appointment || null}
      />
    </div>
  );
}
